import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

function isValidDate(input) {
  dayjs.extend(customParseFormat);
  if (!input) {
    return { isValid: false, inputDate: "" };
  }
  const inputDate =
    typeof input === "object" ? dayjs(input) : dayjs(input, ["YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss", "MM/DD/YYYY h:mm A"]);
  return { isValid: inputDate.isValid(), inputDate };
}

// MM/DD/YYYY
export function getFormattedDateStringNoTime(input) {
  const { isValid, inputDate } = isValidDate(input);
  if (!isValid) {
    return "";
  }
  return inputDate.format("MM/DD/YYYY");
}

export function subtractHours(date, hours) {
  date.setHours(date.getHours() - hours);
  return date;
}

// MM/DD/YYYY HH:mm:ss
export function getFormattedDateStringWithTime(input) {
  const { isValid, inputDate } = isValidDate(input);
  if (!isValid) {
    return "";
  }
  return inputDate.format("MM/DD/YYYY HH:mm:ss");
}

// MM/DD/YYYY hh:mm
export function formatDateTime12Hour(input) {
  const { isValid, inputDate } = isValidDate(input);
  if (!isValid) {
    return "";
  }
  return inputDate.format("MM/DD/YYYY hh:mm A");
}

export function checkValidDate(input) {
  return dayjs(input, "MM/DD/YYYY").isValid();
}

// Month XX, XXXX
export function getLongFormattedDate(dateString) {
  if (!dateString) return "";
  return dayjs(dateString, "YYYY-MM-DD").format("MMMM DD, YYYY");
}

// YYYY-MM-DD
export function getISOFormattedDateNoTime(input) {
  const { isValid, inputDate } = isValidDate(input);
  if (!isValid) {
    return "";
  }
  return inputDate.format("YYYY-MM-DD");
}

// YYYY-MM-DDTHH:mm:ss
export function getISOFormattedDateWithTime(input) {
  const { isValid, inputDate } = isValidDate(input);
  if (!isValid) {
    return "";
  }
  return inputDate.format("YYYY-MM-DDTHH:mm:ss");
}

/**
 * Returns a date string in "YYYY-MM-DD" format.
 *
 * If no date is provided, the current system date is used.
 *
 * @param {Date} [date] - Optional JavaScript Date object. Defaults to current date if not provided.
 * @returns {string} Formatted date string in "YYYY-MM-DD" format.
 *
 * @example
 * getDateInYYYYMMDD(new Date('2025-09-24')); // "2025-09-24"
 * getDateInYYYYMMDD(); // e.g., "2025-09-24" (current date)
 */
export function getDateInYYYYMMDD(date) {
  if (!date) {
    date = new Date();
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Checks whether a given string is a valid date.
 *
 * @param {string} dateString - The input string to validate as a date.
 * @returns {boolean} - Returns true if the string is a valid date, false otherwise.
 */
export function isValidDateString(dateString) {
  if (typeof dateString !== "string" && typeof dateString !== "object") {
    return false;
  }
  const date = new Date(dateString);
  return !Number.isNaN(date.getTime());
}
